import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function ContactSoon() {
  return (
    <div>
      <Header />
      <NavBar />
      <ThemeProvider theme={defaultTheme}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginTop: 10,
            marginBottom: 30,
          }}
        >
          <CssBaseline />
          <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="md">
            <Typography variant="h4" component="h4" gutterBottom sx={{textAlign:'center', color:'#003b82'}}>
              Thank You For Reaching Out!
            </Typography>
            <Typography variant="p" component="p" gutterBottom sx={{textAlign:'center',marginTop:'5%'}}>
              {"Your Order has been recived and our representative Contact you with in 2 Hours."}
         
            </Typography>
            {/* <Typography variant="body1">Sticky footer placeholder.</Typography> */}
          </Container>
        </Box>
      </ThemeProvider>
      <Footer />
    </div>
  );
}
